import React from "react"

import { Popover, PopoverContent, PopoverTrigger, Switch } from "@coval/ui"
import { ArrowUpRight, Info } from "lucide-react"

import { INFO_ICON_STYLES, LABEL_ROW_STYLES } from "../../styles"

const TRACE_SETUP_DOCS_URL =
  "https://docs.coval.ai/concepts/simulations/traces/opentelemetry"

interface TraceContextToggleCardProps {
  enabled: boolean
  onChange: (enabled: boolean) => void
}

export const TraceContextToggleCard: React.FC<TraceContextToggleCardProps> = ({
  enabled,
  onChange,
}) => {
  return (
    <div className="mt-3 rounded-lg border border-coval-border bg-surface-0 px-3 py-2">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <div className={LABEL_ROW_STYLES}>
            <p className="text-sm font-medium text-coval-text">
              Include Traces
            </p>
            <Popover>
              <PopoverTrigger asChild>
                <button
                  type="button"
                  className="inline-flex items-center text-coval-text-muted hover:text-coval-text"
                  aria-label="Trace setup information"
                >
                  <Info className={INFO_ICON_STYLES} />
                </button>
              </PopoverTrigger>
              <PopoverContent side="top" className="max-w-xs p-3">
                <div className="space-y-2 text-sm">
                  <p className="text-coval-text">
                    Your agent must send OpenTelemetry traces to Coval for this
                    to add trace context to the judge.
                  </p>
                  <a
                    href={TRACE_SETUP_DOCS_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1 font-medium text-coval-info-text underline underline-offset-4 hover:text-coval-info-text"
                  >
                    Open trace setup docs
                    <ArrowUpRight className="h-3.5 w-3.5" />
                  </a>
                </div>
              </PopoverContent>
            </Popover>
          </div>
          <p className="text-xs text-coval-text-muted">
            Add matching customer traces to the judge context.
          </p>
        </div>
        <Switch
          checked={enabled}
          onCheckedChange={onChange}
          aria-label="Include traces"
        />
      </div>
    </div>
  )
}
